<template>
  <v-row>
    <!-- Filtros -->
    <v-col cols="12" class="pb-1">
      <v-card elevation="0" outlined style="border-radius: 10px;">
        <v-card-text class="pt-3 pb-2 px-2">
          <v-form>
            <v-row align="center" no-gutters>
              <v-col cols="12" sm class="px-1 mb-2 mb-sm-0">
                <SeletorAdministradoras
                    :administradoras="administradoras"
                    :disabled="carregando"
                    v-model="busca.idadministradora"
                    label="Administradora"
                    @change="get()"
                />
              </v-col>

              <v-col cols="12" sm class="px-1 mb-2 mb-sm-0">
                <SeletorFiliais
                    :filiais="filiaisFiltro"
                    :disabled="carregando"
                    v-model="busca.idfiliais"
                    label="Filiais"
                    :shortcuts="['todas', 'lojas']"
                    @change="get()"
                />
              </v-col>

              <v-col cols="12" sm class="px-1 mb-2 mb-sm-0">
                <SeletorPeriodo
                    :disabled="carregando"
                    v-model="busca.periodo"
                    label="Período"
                    :shortcuts="['periods', 'weeks', 'months', 'quarters', 'years']"
                    @change="get()"
                />
              </v-col>

              <v-col cols="12" sm="auto" class="px-1 d-flex align-center justify-end justify-sm-center">
                <!-- Botão desktop -->
                <v-btn
                    class="primary elevation-0 d-none d-sm-flex"
                    dark
                    icon
                    :loading="carregando"
                    @click="get()"
                    small
                    style="min-width: 32px; width: 32px; height: 32px; padding: 0;"
                >
                  <v-icon small color="white">mdi-refresh</v-icon>
                </v-btn>

                <!-- Botão mobile — linha inteira com descrição -->
                <v-btn
                    class="primary elevation-0 d-flex d-sm-none"
                    dark
                    block
                    :loading="carregando"
                    @click="get()"
                    small
                    style="border-radius: 8px; height: 36px;"
                >
                  <v-icon small left>mdi-refresh</v-icon>
                  Atualizar dados
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- KPI Cards -->
    <v-col cols="12">
      <v-row class="px-2 pt-2">

        <!-- Card: Total Faturado Hoje -->
        <v-col cols="12" md="6" class="pa-1">
          <v-card elevation="0" class="kpi-card" style="border-radius: 10px; overflow: hidden; height: 100%;">
            <div class="kpi-header kpi-header--hoje kpi-header--full">
              <div class="kpi-circle kpi-circle--1"></div>
              <div class="kpi-circle kpi-circle--2"></div>
              <div class="d-flex align-center mb-3">
                <v-icon small color="white" class="mr-1 kpi-icon">mdi-calendar-today</v-icon>
                <div class="kpi-label">Total Faturamento Hoje</div>
                <span class="kpi-label-date">({{ dataHoje }})</span>
                <v-spacer />
                <v-tooltip bottom color="primary" max-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="white" v-bind="attrs" v-on="on" style="opacity: 0.6; cursor: pointer;">mdi-information-outline</v-icon>
                  </template>
                  <span>Comparativo de faturamento de hoje entre todas as administradoras e a selecionada.</span>
                </v-tooltip>
              </div>
              <div class="kpi-split-row">
                <div class="kpi-split-col">
                  <div class="kpi-chip">
                    <v-icon style="font-size:10px; opacity:0.7;" color="white">mdi-view-grid-outline</v-icon>
                    <span class="kpi-chip-text">Todas administradoras</span>
                  </div>
                  <template v-if="carregando">
                    <div class="kpi-skeleton kpi-skeleton--value"></div>
                  </template>
                  <div v-else class="kpi-value">{{ totalGeralHoje | formataDinheiro }}</div>
                </div>
                <div class="kpi-split-divider"></div>
                <div class="kpi-split-col">
                  <div class="kpi-chip">
                    <v-icon style="font-size:10px; opacity:0.7;" color="white">mdi-credit-card-outline</v-icon>
                    <span class="kpi-chip-text">{{ administradoraSelecionada }}</span>
                  </div>
                  <template v-if="carregando">
                    <div class="kpi-skeleton kpi-skeleton--value"></div>
                  </template>
                  <div v-else class="kpi-value">{{ totalHoje | formataDinheiro }}</div>
                </div>
                <div class="kpi-split-divider"></div>
                <div class="kpi-split-col">
                  <div class="kpi-chip">
                    <v-icon style="font-size:10px; opacity:0.7;" color="white">mdi-chart-bar</v-icon>
                    <span class="kpi-chip-text">Participação</span>
                  </div>
                  <template v-if="carregando">
                    <div class="kpi-skeleton kpi-skeleton--value kpi-skeleton--short"></div>
                  </template>
                  <div v-else class="kpi-value">{{ participacaoHoje }}%</div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

        <!-- Card: Total Faturado Período -->
        <v-col cols="12" md="6" class="pa-1">
          <v-card elevation="0" class="kpi-card" style="border-radius: 10px; overflow: hidden; height: 100%;">
            <div class="kpi-header kpi-header--periodo kpi-header--full">
              <div class="kpi-circle kpi-circle--1"></div>
              <div class="kpi-circle kpi-circle--2"></div>
              <div class="d-flex align-center mb-3">
                <v-icon small color="white" class="mr-1 kpi-icon">mdi-calendar-range</v-icon>
                <div class="kpi-label">Total Faturamento Período</div>
                <v-spacer />
                <v-tooltip bottom color="primary" max-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon small color="white" v-bind="attrs" v-on="on" style="opacity: 0.6; cursor: pointer;">mdi-information-outline</v-icon>
                  </template>
                  <span>Comparativo de faturamento do período entre todas as administradoras e a selecionada.</span>
                </v-tooltip>
              </div>
              <div class="kpi-split-row">
                <div class="kpi-split-col">
                  <div class="kpi-chip">
                    <v-icon style="font-size:10px; opacity:0.7;" color="white">mdi-view-grid-outline</v-icon>
                    <span class="kpi-chip-text">Todas administradoras</span>
                  </div>
                  <template v-if="carregando">
                    <div class="kpi-skeleton kpi-skeleton--value"></div>
                  </template>
                  <div v-else class="kpi-value">{{ totalGeral | formataDinheiro }}</div>
                </div>
                <div class="kpi-split-divider"></div>
                <div class="kpi-split-col">
                  <div class="kpi-chip">
                    <v-icon style="font-size:10px; opacity:0.7;" color="white">mdi-credit-card-outline</v-icon>
                    <span class="kpi-chip-text">{{ administradoraSelecionada }}</span>
                  </div>
                  <template v-if="carregando">
                    <div class="kpi-skeleton kpi-skeleton--value"></div>
                  </template>
                  <div v-else class="kpi-value">{{ totalPeriodo | formataDinheiro }}</div>
                </div>
                <div class="kpi-split-divider"></div>
                <div class="kpi-split-col">
                  <div class="kpi-chip">
                    <v-icon style="font-size:10px; opacity:0.7;" color="white">mdi-chart-bar</v-icon>
                    <span class="kpi-chip-text">Participação</span>
                  </div>
                  <template v-if="carregando">
                    <div class="kpi-skeleton kpi-skeleton--value kpi-skeleton--short"></div>
                  </template>
                  <div v-else class="kpi-value">{{ participacaoGeral }}%</div>
                </div>
              </div>
            </div>
          </v-card>
        </v-col>

      </v-row>
    </v-col>

    <!-- Tabela principal -->
    <v-col cols="12">
      <v-card elevation="0" outlined style="border-radius: 10px; overflow: hidden;">
        <v-progress-linear indeterminate absolute :active="carregando" color="primary" />

        <div class="table-header">
          <v-icon color="white" class="mr-2" style="opacity: 0.85;">mdi-store</v-icon>
          <div>
            <div class="table-header-title">Faturamento por filial</div>
            <div class="table-header-subtitle">Administradora: {{ administradoraSelecionada }}</div>
          </div>
        </div>

        <!-- ── Visão Desktop ─────────────────────────────────────────────────── -->
        <div class="d-none d-md-block">
          <v-simple-table>
            <thead>
            <tr class="thead-row">
              <th class="col-expand"></th>
              <th
                  class="text-caption font-weight-bold thead-th col-codigo sortable-th"
                  @click="setSort('filial', 'idempresa')"
              >
                Código
                <v-icon x-small class="sort-icon">{{ sortIcon('filial', 'idempresa') }}</v-icon>
              </th>
              <th
                  class="text-caption font-weight-bold thead-th sortable-th"
                  @click="setSort('filial', 'empresa')"
              >
                Filial
                <v-icon x-small class="sort-icon">{{ sortIcon('filial', 'empresa') }}</v-icon>
              </th>
              <th
                  class="text-center text-caption font-weight-bold thead-th col-qtde sortable-th"
                  @click="setSort('filial', 'qtd_titulos')"
              >
                Qtde Títulos
                <v-icon x-small class="sort-icon">{{ sortIcon('filial', 'qtd_titulos') }}</v-icon>
              </th>
              <th
                  class="text-right text-caption font-weight-bold thead-th col-fat-hoje sortable-th"
                  @click="setSort('filial', 'total_hoje')"
              >
                Faturamento hoje
                <v-icon x-small class="sort-icon">{{ sortIcon('filial', 'total_hoje') }}</v-icon>
              </th>
              <th
                  class="text-right text-caption font-weight-bold thead-th col-fat-periodo sortable-th"
                  @click="setSort('filial', 'total')"
              >
                Faturamento período
                <v-icon x-small class="sort-icon">{{ sortIcon('filial', 'total') }}</v-icon>
              </th>
              <th
                  class="text-right text-caption font-weight-bold thead-th col-participacao sortable-th"
                  @click="setSort('filial', 'participacao')"
              >
                Participação
                <v-icon x-small class="sort-icon">{{ sortIcon('filial', 'participacao') }}</v-icon>
              </th>
            </tr>
            </thead>

            <tbody v-if="carregando">
            <tr
                v-for="(row, i) in skeletonRows"
                :key="`sk-${i}`"
                class="skeleton-row"
                :style="{ opacity: 1 - i * 0.15 }"
            >
              <td class="col-expand text-center">
                <div class="sk sk-circle" style="width: 14px; height: 14px; border-radius: 50%; margin: 0 auto;"></div>
              </td>
              <td class="col-codigo">
                <div class="sk sk-text" :style="{ width: row.codigo + 'px' }"></div>
              </td>
              <td>
                <div class="sk sk-text" :style="{ width: row.nome + 'px' }"></div>
              </td>
              <td class="col-qtde text-center">
                <div class="sk sk-chip" style="width: 44px; margin: 0 auto;"></div>
              </td>
              <td class="col-fat-hoje text-right">
                <div class="sk sk-text" :style="{ width: row.hoje + 'px', marginLeft: 'auto' }"></div>
              </td>
              <td class="col-fat-periodo text-right">
                <div class="sk sk-text sk-text--bold" :style="{ width: row.periodo + 'px', marginLeft: 'auto' }"></div>
              </td>
              <td class="col-participacao">
                <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 5px;">
                  <div class="sk sk-text" :style="{ width: row.pct + 'px' }"></div>
                  <div class="sk sk-bar" style="width: 60px;"></div>
                </div>
              </td>
            </tr>
            </tbody>

            <tbody v-else-if="faturamentoPorFilial.length">
            <template v-for="(filial, i) in faturamentoPorFilial">
              <tr
                  :key="`filial-${i}`"
                  class="filial-row"
                  :class="{ 'filial-row--active': expanded === filial.idempresa }"
                  @click="toggleFilial(filial.idempresa)"
              >
                <td class="text-center col-expand">
                  <v-icon small class="expand-icon" :class="{ 'expand-icon--open': expanded === filial.idempresa }">
                    mdi-chevron-right
                  </v-icon>
                </td>
                <td class="text-caption filial-id col-codigo">{{ filial.idempresa }}</td>
                <td class="filial-name">{{ filial.empresa }}</td>
                <td class="text-center col-qtde">
                  <v-chip x-small color="primary" outlined style="font-weight: 600;">{{ filial.qtd_titulos }}</v-chip>
                </td>
                <td class="text-right filial-hoje col-fat-hoje tpadding-value">{{ filial.total_hoje | formataDinheiro }}</td>
                <td class="text-right filial-total col-fat-periodo tpadding-value">{{ filial.total | formataDinheiro }}</td>
                <td class="text-right col-participacao">
                  <div class="participacao-wrapper">
                    <span class="participacao-valor">{{ filial.participacao }}%</span>
                    <div class="participacao-bar">
                      <div class="participacao-bar-fill" :style="{ width: filial.participacao + '%' }"></div>
                    </div>
                  </div>
                </td>
              </tr>

              <template v-if="expanded === filial.idempresa">
                <tr :key="`cli-expand-${i}`" class="subtable-wrapper-row">
                  <td colspan="8" class="pa-0 subtable-wrapper-td">
                    <div class="subtable-container">
                      <v-simple-table dense class="subtable">
                        <thead>
                        <tr class="subtable-thead">
                          <th class="text-caption font-weight-medium subtable-th pl-8 sortable-th" @click="setSort('titulo', 'cliente')">
                            Cliente <v-icon x-small class="sort-icon">{{ sortIcon('titulo', 'cliente') }}</v-icon>
                          </th>
                          <th class="text-caption font-weight-medium subtable-th col-titulo sortable-th" @click="setSort('titulo', 'idtitulo')">
                            Título <v-icon x-small class="sort-icon">{{ sortIcon('titulo', 'idtitulo') }}</v-icon>
                          </th>
                          <th class="text-caption font-weight-medium subtable-th col-dt-movimento sortable-th" @click="setSort('titulo', 'dt_movimento')">
                            Dt. Movimento <v-icon x-small class="sort-icon">{{ sortIcon('titulo', 'dt_movimento') }}</v-icon>
                          </th>
                          <th class="text-caption font-weight-medium subtable-th col-dt-vencimento sortable-th" @click="setSort('titulo', 'dt_vencimento')">
                            Dt. Vencimento <v-icon x-small class="sort-icon">{{ sortIcon('titulo', 'dt_vencimento') }}</v-icon>
                          </th>
                          <th class="text-right text-caption font-weight-medium subtable-th col-valor sortable-th" @click="setSort('titulo', 'val_titulo')">
                            Valor <v-icon x-small class="sort-icon">{{ sortIcon('titulo', 'val_titulo') }}</v-icon>
                          </th>
                          <th class="text-right text-caption font-weight-medium subtable-th col-conciliado sortable-th" @click="setSort('titulo', 'flag_baixada')">
                            Conciliado <v-icon x-small class="sort-icon">{{ sortIcon('titulo', 'flag_baixada') }}</v-icon>
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="(titulo, j) in filial.titulos"
                            :key="`cli-${i}-${j}`"
                            class="cliente-row"
                        >
                          <td class="text-caption cliente-name pl-8">
                            {{ titulo.cliente }}
                            <span class="cliente-id">({{ titulo.idclifor }})</span>
                          </td>
                          <td class="text-caption col-titulo" style="color: #5a6a7a;">
                            {{ titulo.idtitulo }}<span style="color: #b0bec5;"> - {{ titulo.digito_titulo }}</span>
                          </td>
                          <td class="text-caption col-dt-movimento" style="color: #5a6a7a;">{{ titulo.dt_movimento | formataData }}</td>
                          <td class="text-caption col-dt-vencimento" style="color: #5a6a7a;">{{ titulo.dt_vencimento | formataData }}</td>
                          <td class="text-right text-caption cliente-valor col-valor">{{ titulo.val_titulo | formataDinheiro }}</td>
                          <td class="text-right text-caption col-conciliado">
                            <v-chip x-small :color="titulo.flag_baixada === 'T' ? 'success' : 'warning'" dark style="font-size: 10px; font-weight: 500;">
                              <v-icon x-small left>{{ titulo.flag_baixada === 'T' ? 'mdi-check' : 'mdi-clock-outline' }}</v-icon>
                              {{ titulo.flag_baixada === 'T' ? 'Sim' : 'Não' }}
                            </v-chip>
                          </td>
                        </tr>
                        </tbody>
                      </v-simple-table>
                    </div>
                  </td>
                </tr>
              </template>
            </template>
            </tbody>

            <tbody v-else>
            <tr>
              <td colspan="8" class="text-center pa-8">
                <div class="d-flex flex-column align-center">
                  <v-icon size="40" color="grey lighten-2" class="mb-2">mdi-file-search-outline</v-icon>
                  <span class="grey--text text--lighten-1 body-2">Nenhum registro encontrado.</span>
                </div>
              </td>
            </tr>
            </tbody>

            <tfoot v-if="!carregando && faturamentoPorFilial.length">
            <tr class="tfoot-row">
              <td></td>
              <td></td>
              <td class="tfoot-label">Total geral</td>
              <td class="text-center font-weight-bold" style="font-size: 13px;">{{ totalTitulos }}</td>
              <td class="text-right tfoot-value tpadding-value">{{ totalHoje | formataDinheiro }}</td>
              <td class="text-right tfoot-value tpadding-value">{{ totalPeriodo | formataDinheiro }}</td>
              <td class="text-right tfoot-value">{{ participacaoGeral }}%</td>
            </tr>
            </tfoot>
          </v-simple-table>
        </div>

        <!-- ── Visão Mobile ──────────────────────────────────────────────────── -->
        <div class="d-block d-md-none mobile-cards-wrapper">

          <!-- Skeleton mobile -->
          <template v-if="carregando">
            <div
                v-for="(row, i) in skeletonRows"
                :key="`msk-${i}`"
                class="mobile-filial-card"
                :style="{ opacity: 1 - i * 0.15 }"
            >
              <div class="mobile-card-header">
                <div style="display:flex; flex-direction:column; gap:6px; flex:1;">
                  <div class="sk sk-text" style="width: 40px;"></div>
                  <div class="sk sk-text" :style="{ width: row.nome + 'px', maxWidth: '100%' }"></div>
                </div>
                <div class="sk sk-chip" style="width: 36px;"></div>
              </div>
              <div class="mobile-card-metrics">
                <div class="mobile-metric" v-for="n in 3" :key="n">
                  <div class="sk sk-text" style="width: 60px; margin-bottom: 4px;"></div>
                  <div class="sk sk-text sk-text--bold" style="width: 80px;"></div>
                </div>
              </div>
            </div>
          </template>

          <!-- Cards reais -->
          <template v-else-if="faturamentoPorFilial.length">
            <div
                v-for="(filial, i) in faturamentoPorFilial"
                :key="`mcard-${i}`"
                class="mobile-filial-card"
                :class="{ 'mobile-filial-card--active': expanded === filial.idempresa }"
            >
              <!-- Cabeçalho do card -->
              <div class="mobile-card-header" @click="toggleFilial(filial.idempresa)">
                <div class="mobile-card-identity">
                  <span class="mobile-card-nome">{{ filial.empresa }}</span>
                  <span class="mobile-card-codigo">({{ filial.idempresa }})</span>
                </div>
                <div class="mobile-card-header-right">
                  <v-chip x-small color="primary" outlined style="font-weight: 600;">
                    {{ filial.qtd_titulos }}
                  </v-chip>
                  <v-icon small class="mobile-expand-icon" :class="{ 'mobile-expand-icon--open': expanded === filial.idempresa }">
                    mdi-chevron-down
                  </v-icon>
                </div>
              </div>

              <!-- Métricas -->
              <div class="mobile-card-metrics" @click="toggleFilial(filial.idempresa)">
                <div class="mobile-metric">
                  <span class="mobile-metric-label">Fat. Hoje</span>
                  <span class="mobile-metric-value">{{ filial.total_hoje | formataDinheiro }}</span>
                </div>
                <div class="mobile-metric-divider"></div>
                <div class="mobile-metric">
                  <span class="mobile-metric-label">Fat. Período</span>
                  <span class="mobile-metric-value mobile-metric-value--destaque">{{ filial.total | formataDinheiro }}</span>
                </div>
                <div class="mobile-metric-divider"></div>
                <div class="mobile-metric">
                  <span class="mobile-metric-label">Participação</span>
                  <div class="mobile-metric-participacao">
                    <span class="mobile-metric-value">{{ filial.participacao }}%</span>
                    <div class="participacao-bar" style="width: 48px;">
                      <div class="participacao-bar-fill" :style="{ width: filial.participacao + '%' }"></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Títulos expandidos -->
              <transition name="mobile-expand">
                <div v-if="expanded === filial.idempresa" class="mobile-titulos-wrapper">
                  <div class="mobile-titulos-header">
                    <v-icon x-small color="white" class="mr-1">mdi-receipt-text-outline</v-icon>
                    <span>Títulos</span>
                  </div>

                  <div
                      v-for="(titulo, j) in filial.titulos"
                      :key="`mt-${i}-${j}`"
                      class="mobile-titulo-card"
                  >
                    <div class="mobile-titulo-top">
                      <div class="mobile-titulo-cliente">
                        {{ titulo.cliente }}
                        <span class="mobile-titulo-id">({{ titulo.idclifor }})</span>
                      </div>
                      <v-chip
                          x-small
                          :color="titulo.flag_baixada === 'T' ? 'success' : 'warning'"
                          dark
                          style="font-size: 10px; font-weight: 500;"
                      >
                        <v-icon x-small left>{{ titulo.flag_baixada === 'T' ? 'mdi-check' : 'mdi-clock-outline' }}</v-icon>
                        {{ titulo.flag_baixada === 'T' ? 'Sim' : 'Não' }}
                      </v-chip>
                    </div>
                    <div class="mobile-titulo-details">
                      <div class="mobile-titulo-field">
                        <span class="mobile-titulo-field-label">Título</span>
                        <span class="mobile-titulo-field-value">{{ titulo.idtitulo }} <span style="color:#b0bec5;">- {{ titulo.digito_titulo }}</span></span>
                      </div>
                      <div class="mobile-titulo-field">
                        <span class="mobile-titulo-field-label">Dt. Movimento</span>
                        <span class="mobile-titulo-field-value">{{ titulo.dt_movimento | formataData }}</span>
                      </div>
                      <div class="mobile-titulo-field">
                        <span class="mobile-titulo-field-label">Dt. Vencimento</span>
                        <span class="mobile-titulo-field-value">{{ titulo.dt_vencimento | formataData }}</span>
                      </div>
                      <div class="mobile-titulo-field">
                        <span class="mobile-titulo-field-label">Valor</span>
                        <span class="mobile-titulo-field-value mobile-titulo-valor">{{ titulo.val_titulo | formataDinheiro }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>

            <!-- Total mobile -->
            <div class="mobile-total-card">
              <span class="mobile-total-label">Total geral</span>
              <div class="mobile-total-metrics">
                <div class="mobile-metric">
                  <span class="mobile-metric-label">Títulos</span>
                  <span class="mobile-metric-value">{{ totalTitulos }}</span>
                </div>
                <div class="mobile-metric-divider"></div>
                <div class="mobile-metric">
                  <span class="mobile-metric-label">Fat. Hoje</span>
                  <span class="mobile-metric-value">{{ totalHoje | formataDinheiro }}</span>
                </div>
                <div class="mobile-metric-divider"></div>
                <div class="mobile-metric">
                  <span class="mobile-metric-label">Fat. Período</span>
                  <span class="mobile-metric-value mobile-metric-value--destaque">{{ totalPeriodo | formataDinheiro }}</span>
                </div>
              </div>
            </div>
          </template>

          <!-- Vazio mobile -->
          <div v-else class="mobile-empty">
            <v-icon size="40" color="grey lighten-2" class="mb-2">mdi-file-search-outline</v-icon>
            <span class="grey--text text--lighten-1 body-2">Nenhum registro encontrado.</span>
          </div>
        </div>

      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import SeletorPeriodo from "../UI/Inputs/SeletorPeriodo.vue";
import SeletorFiliais from "../UI/Inputs/SeletorFiliais.vue";
import SeletorAdministradoras from "../UI/Inputs/SeletorAdministradoras.vue";
import mixinFilial from "../../util/mixinFilial";

export default {
  name: "DashboardCartoes",
  mixins: [mixinFilial],
  components: { SeletorPeriodo, SeletorFiliais, SeletorAdministradoras },
  data: () => ({
    carregando: false,
    dados: null,
    administradoras: [],
    expanded: null,
    sort: {
      filial: { key: "idempresa", dir: 1 },
      titulo: { key: null, dir: 1 },
    },
    busca: {
      periodo: {
        inicio: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-01`,
        fim: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, "0")}-${String(new Date().getDate()).padStart(2, "0")}`,
      },
      idfiliais: [],
      idadministradora: 28,
    },
    skeletonRows: [
      { codigo: 38, nome: 140, hoje: 92, periodo: 105, pct: 32 },
      { codigo: 44, nome: 110, hoje: 86, periodo:  95, pct: 28 },
      { codigo: 38, nome: 160, hoje: 98, periodo: 115, pct: 38 },
      { codigo: 42, nome: 125, hoje: 80, periodo:  90, pct: 24 },
      { codigo: 40, nome: 150, hoje: 94, periodo: 100, pct: 30 },
    ],
  }),
  computed: {
    ...mapState(["backendUrl", "pgLimit", "usuario"]),

    dataHoje() {
      return new Date().toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },

    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial !== 4  && v.idfilial !== 6  && v.idfilial !== 12 &&
              v.idfilial !== 13 && v.idfilial !== 25 && v.idfilial !== 28 &&
              v.idfilial !== 29 && v.idfilial !== 33 && v.idfilial !== 39 &&
              v.idfilial !== 42 && v.idfilial !== 43 && v.idfilial !== 37
          );
        });
      } else {
        return [];
      }
    },

    administradoraSelecionada() {
      if (!this.busca.idadministradora) return "Todas";
      const adm = this.administradoras.find(a => a.idadministradora === this.busca.idadministradora);
      return adm ? adm.administradora : "—";
    },

    totalHoje()        { return this.dados?.totais?.hoje?.total_adm      || 0; },
    totalPeriodo()     { return this.dados?.totais?.periodo?.total_adm   || 0; },
    totalGeralHoje()   { return this.dados?.totais?.hoje?.total_geral    || 0; },
    totalGeral()       { return this.dados?.totais?.periodo?.total_geral || 0; },

    participacaoHoje() {
      return (this.dados?.totais?.hoje?.participacao    || 0).toFixed(2);
    },
    participacaoGeral() {
      return (this.dados?.totais?.periodo?.participacao || 0).toFixed(2);
    },

    totalTitulos() {
      if (!this.dados?.filiais) return 0;
      return this.dados.filiais.reduce((sum, f) => sum + f.qtd_titulos, 0);
    },

    faturamentoPorFilial() {
      if (!this.dados?.filiais) return [];
      const { key, dir } = this.sort.filial;
      return [...this.dados.filiais]
          .map(filial => ({
            ...filial,
            participacao: parseFloat(filial.participacao).toFixed(1),
            titulos: this.sortTitulos(filial.titulos),
          }))
          .sort((a, b) => {
            const va = a[key], vb = b[key];
            const na = parseFloat(va), nb = parseFloat(vb);
            if (!isNaN(na) && !isNaN(nb)) return (na - nb) * dir;
            return String(va).localeCompare(String(vb)) * dir;
          });
    },
  },

  methods: {
    get() {
      this.dados = null;
      this.expanded = null;
      this.carregando = true;

      const params = {
        idadministradora: this.busca.idadministradora,
        dtinicio: this.busca.periodo.inicio,
        dtfim: this.busca.periodo.fim,
        idfiliais: this.busca.idfiliais?.length > 0 ? this.busca.idfiliais : [],
      };

      return axios
          .post(`${this.backendUrl}dashboard/faturamento/administradoras`, params)
          .then((res) => { this.dados = res.data; })
          .catch((err) => {
            console.error("Erro ao buscar faturamento:", err);
            this.$root.$snackbar.showError("Erro ao carregar dados do dashboard");
          })
          .finally(() => { this.carregando = false; });
    },

    listarAdministradoras() {
      return axios
          .post(`${this.backendUrl}dashboard/administradoras/listar`)
          .then((res) => {
            this.administradoras = res.data || [];
            if (this.administradoras.length > 0 && !this.busca.idadministradora) {
              this.busca.idadministradora = this.administradoras[0].idadministradora;
            }
          })
          .catch((err) => {
            console.error("Erro ao listar administradoras:", err);
            this.$root.$snackbar.showError("Erro ao carregar administradoras");
          });
    },

    // Expand exclusivo: abre um, fecha o anterior
    toggleFilial(id) {
      this.expanded = this.expanded === id ? null : id;
    },

    setSort(nivel, key) {
      if (this.sort[nivel].key === key) {
        this.sort[nivel].dir *= -1;
      } else {
        this.sort[nivel].key = key;
        this.sort[nivel].dir = 1;
      }
    },

    sortIcon(nivel, key) {
      if (this.sort[nivel].key !== key) return "mdi-unfold-more-horizontal";
      return this.sort[nivel].dir === 1 ? "mdi-arrow-up" : "mdi-arrow-down";
    },

    sortTitulos(titulos) {
      if (!titulos?.length) return [];
      const { key, dir } = this.sort.titulo;
      if (!key) return [...titulos];

      const dateCols = ['dt_movimento', 'dt_vencimento'];

      return [...titulos].sort((a, b) => {
        const va = a[key], vb = b[key];

        if (dateCols.includes(key)) {
          // Converte "YYYY-MM-DD" ou "DD/MM/YYYY" para Date comparável
          const toDate = (str) => {
            if (!str) return 0;
            // Se vier como YYYY-MM-DD (ISO)
            if (/^\d{4}-\d{2}-\d{2}/.test(str)) return new Date(str).getTime();
            // Se vier como DD/MM/YYYY
            const [d, m, y] = str.split('/');
            return new Date(`${y}-${m}-${d}`).getTime();
          };
          return (toDate(va) - toDate(vb)) * dir;
        }

        const na = parseFloat(va), nb = parseFloat(vb);
        if (!isNaN(na) && !isNaN(nb)) return (na - nb) * dir;
        return String(va).localeCompare(String(vb)) * dir;
      });
    },

    async init() {
      await this.listarAdministradoras();
      await this.get();
    },
  },

  watch: {
    filiaisFiltro: {
      handler(lista) {
        if (lista.length > 0 && this.busca.idfiliais.length === 0) {
          this.busca.idfiliais = lista.map(f => f.idfilial);
        }
      },
      immediate: true,
    },
  },

  created() {
    this.init();
  },
};
</script>

<style scoped>
/* ── Skeleton ──────────────────────────────────────────────────────────────── */
@keyframes shimmer {
  0%   { background-position: -600px 0; }
  100% { background-position:  600px 0; }
}
.sk {
  display: block;
  border-radius: 4px;
  background: linear-gradient(90deg, #dde6ee 25%, #edf3f8 50%, #dde6ee 75%);
  background-size: 600px 100%;
  animation: shimmer 1.4s infinite linear;
}
.sk-text        { height: 13px; }
.sk-text--bold  { height: 14px; }
.sk-chip        { height: 20px; border-radius: 10px; }
.sk-bar         { height: 4px;  border-radius: 2px; }
.sk-circle      { border-radius: 50%; }

.skeleton-row td { padding-top: 13px !important; padding-bottom: 13px !important; }

/* ── Skeleton nos KPI cards (fundo escuro - shimmer branco) ────────────────── */
.kpi-skeleton {
  border-radius: 4px;
  background: linear-gradient(
      90deg,
      rgba(255,255,255,0.12) 25%,
      rgba(255,255,255,0.28) 50%,
      rgba(255,255,255,0.12) 75%
  );
  background-size: 400px 100%;
  animation: shimmer 1.4s infinite linear;
  margin-top: 4px;
}
.kpi-skeleton--value { height: 22px; width: 100%; max-width: 110px; border-radius: 4px; }
.kpi-skeleton--short { max-width: 60px; }

/* ── KPI Cards ─────────────────────────────────────────────────────────────── */
.kpi-card { border: 1px solid #e0e0e0; }
.kpi-header {
  padding: 16px 18px 14px;
  position: relative;
  overflow: hidden;
}
.kpi-header--full    { height: 100%; box-sizing: border-box; }
.kpi-header--hoje    { background: linear-gradient(135deg, #023449 0%, #035878 100%); }
.kpi-header--periodo { background: linear-gradient(135deg, #0d3550 0%, #0477a1 100%); }

.kpi-circle { position: absolute; border-radius: 50%; background: rgba(255,255,255,0.06); }
.kpi-circle--1 { width: 110px; height: 110px; right: -22px; top: -22px; }
.kpi-circle--2 { width:  75px; height:  75px; right:  24px; bottom: -32px; }
.kpi-icon  { opacity: 0.75; }
.kpi-label {
  font-size: 13px;
  color: rgba(255,255,255,0.95);
  font-weight: 700;
  letter-spacing: 0.2px;
  line-height: 1.2;
}

.kpi-split-row {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) 20px minmax(0, 1.4fr) 20px minmax(0, 0.9fr);
  position: relative;
  z-index: 1;
  align-items: start;
}
.kpi-split-divider { display: flex; align-items: stretch; justify-content: center; }
.kpi-split-divider::after {
  content: '';
  display: block;
  width: 1px;
  background: rgba(255,255,255,0.25);
  align-self: stretch;
  min-height: 50px;
}
.kpi-split-col                { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.kpi-split-col:nth-child(1)   { padding-right: 8px; }
.kpi-split-col:nth-child(3)   { padding: 0 8px; }
.kpi-split-col:nth-child(5)   { padding-left: 8px; }

.kpi-value {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.5px;
  line-height: 1.15;
  white-space: nowrap;
}
.kpi-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(255,255,255,0.12);
  border-radius: 4px;
  padding: 3px 7px;
  width: fit-content;
  margin-bottom: 3px;
}
.kpi-chip-text {
  font-size: 9px;
  color: rgba(255,255,255,0.8);
  font-weight: 500;
  white-space: nowrap;
}
.kpi-label-date {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 400;
  margin-left: 6px;
}

@media (max-width: 599px) {
  .kpi-split-row {
    grid-template-columns: 1fr !important;
    gap: 12px;
  }
  .kpi-split-divider { display: none; }
  .kpi-split-col:nth-child(1),
  .kpi-split-col:nth-child(3),
  .kpi-split-col:nth-child(5) { padding: 0; }
  .kpi-split-col { flex-direction: row; align-items: center; justify-content: space-between; }
  .kpi-value { font-size: 16px; }
  .kpi-chip { margin-bottom: 0; }
}

/* ── Table header ──────────────────────────────────────────────────────────── */
.table-header {
  background: linear-gradient(135deg, #023449 0%, #035878 100%);
  padding: 12px 20px;
  display: flex;
  align-items: center;
}
.table-header-title {
  color: white;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.2px;
  line-height: 1.3;
}
.table-header-subtitle {
  color: rgba(255,255,255,0.6);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.3px;
  margin-top: 1px;
}

/* ── Expand icon ───────────────────────────────────────────────────────────── */
.expand-icon { color: #b0bec5 !important; transition: transform 0.2s ease, color 0.2s ease; }
.expand-icon--open { transform: rotate(90deg); color: #023449 !important; }
.filial-row:hover .expand-icon { color: #023449 !important; }

/* ── Thead ─────────────────────────────────────────────────────────────────── */
.thead-row { background-color: #f5f7f9; }
.thead-th  { color: #5a6a7a !important; }

/* ── Sort ──────────────────────────────────────────────────────────────────── */
.sortable-th {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.sortable-th:hover { background-color: #e8edf2; }
.sort-icon { opacity: 0.35; margin-left: 2px; vertical-align: middle; transition: opacity 0.15s ease; }
.sortable-th:hover .sort-icon { opacity: 0.75; }

/* ── Filial rows ───────────────────────────────────────────────────────────── */
.filial-row { cursor: pointer; transition: background-color 0.15s ease; }
.filial-row:hover { background-color: #f0f5f8 !important; }
.filial-row--active { background-color: #e3edf5 !important; }
.filial-row--active:hover { background-color: #d8e7f1 !important; }
.filial-id    { color: #9aacbc; }
.filial-name  { font-weight: 500; font-size: 13px; }
.filial-hoje  { font-size: 13px; color: #5a6a7a; }
.filial-total { font-weight: 600; font-size: 13px; color: #023449;  }

/* ── Participação ──────────────────────────────────────────────────────────── */
.participacao-wrapper { display: flex; flex-direction: column; align-items: flex-end; gap: 3px; }
.participacao-valor   { font-size: 12px; font-weight: 600; color: #023449; }
.participacao-bar     { width: 60px; height: 4px; background: #dde4ec; border-radius: 2px; overflow: hidden; }
.participacao-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #035878, #0477a1);
  border-radius: 2px;
  transition: width 0.4s ease;
}

/* ── Subtable ──────────────────────────────────────────────────────────────── */
.subtable-wrapper-row { background: transparent !important; }
.subtable-wrapper-td  { border-top: 2px solid #9ab8cc !important; border-bottom: 2px solid #7aa0b8 !important; }
.subtable-container {
  border-left: 3px solid transparent;
  border-image: linear-gradient(to bottom, #0477a1, #023449) 1;
  background: #eef4f8;
}
.subtable             { background: transparent !important; width: 100%; }
.subtable-thead       { background: linear-gradient(135deg, #1a5a73 0%, #1e7aa0 100%) !important; }
.subtable-th {
  color: rgba(255,255,255,0.82) !important;
  border-bottom: none !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.subtable-th.sortable-th:hover { background-color: rgba(255,255,255,0.10) !important; }

.cliente-row:nth-child(odd)  { background-color: #eef4f8 !important; }
.cliente-row:nth-child(even) { background-color: #e4ecf3 !important; }
.cliente-row:hover            { background-color: #d6e6f0 !important; }
.cliente-row                  { transition: background-color 0.12s ease; }
.cliente-name                 { color: #2c3e50; font-weight: 500; }
.cliente-id                   { display: inline; font-size: 10px; color: #8fa8bc; font-weight: 400; margin-left: 5px; }
.cliente-valor                { color: #023449; font-weight: 600; }

/* ── Column widths ─────────────────────────────────────────────────────────── */
.col-expand       { width:  52px; min-width:  52px; }
.col-codigo       { width:  70px; min-width:  70px; }
.col-qtde         { width: 110px; min-width:  90px; }
.col-fat-hoje     { width: 190px; min-width: 120px; }
.col-fat-periodo  { width: 190px; min-width: 120px; }
.col-participacao { width: 130px; min-width: 100px; }
.col-titulo       { width: 110px; min-width: 130px; }
.col-dt-movimento { width: 130px; min-width: 125px; }
.col-dt-vencimento{ width: 130px; min-width: 125px; }
.col-valor        { width: 140px; min-width: 130px; }
.col-conciliado   { width: 130px; min-width: 100px; }

/* ── Tfoot ─────────────────────────────────────────────────────────────────── */
.tfoot-row   { background: #f0f4f8; border-top: 2px solid #cfd8e3; }
.tfoot-label { font-size: 12px; font-weight: 700; color: #023449; text-transform: uppercase; letter-spacing: 0.4px; }
.tfoot-value { font-weight: 700; font-size: 13px; color: #023449; }
.tpadding-value {  padding-right: 32px !important; }

/* ── Mobile cards ──────────────────────────────────────────────────────────── */
.mobile-cards-wrapper { padding: 8px; display: flex; flex-direction: column; gap: 8px; }

.mobile-filial-card {
  margin-bottom: 12px;
  border: 1px solid #dde6ee;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  transition: box-shadow 0.2s ease;
}
.mobile-filial-card--active {
  border-color: #7ab8d0;
  box-shadow: 0 2px 10px rgba(2, 52, 73, 0.10);
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  cursor: pointer;
  background: #f5f8fa;
  gap: 8px;
}
.mobile-filial-card--active .mobile-card-header { background: #e8f0f6; }

.mobile-card-identity { display: flex; flex-direction: row; gap: 2px; flex: 1; min-width: 0; }
.mobile-card-codigo   { font-size: 10px; color: #9aacbc; font-weight: 500; margin-left: 5px; }
.mobile-card-nome     { font-size: 13px; font-weight: 600; color: #023449; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

.mobile-card-header-right { display: flex; align-items: center; gap: 6px; flex-shrink: 0; }

.mobile-expand-icon { color: #b0bec5 !important; transition: transform 0.2s ease; }
.mobile-expand-icon--open { transform: rotate(180deg); color: #023449 !important; }

.mobile-card-metrics {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  border-top: 1px solid #eef2f6;
}
.mobile-metric { display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 0; }
.mobile-metric-label { font-size: 9px; color: #8fa8bc; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; }
.mobile-metric-value { font-size: 12px; font-weight: 600; color: #3d5166; white-space: nowrap; }
.mobile-metric-value--destaque { color: #023449; font-size: 13px; }
.mobile-metric-participacao { display: flex; flex-direction: column; gap: 4px; }
.mobile-metric-divider { width: 1px; background: #dde6ee; align-self: stretch; margin: 0 10px; flex-shrink: 0; }

/* ── Títulos expandidos mobile ─────────────────────────────────────────────── */
.mobile-titulos-wrapper { border-top: 2px solid #9ab8cc; }

.mobile-titulos-header {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background: linear-gradient(135deg, #1a5a73 0%, #1e7aa0 100%);
  font-size: 11px;
  font-weight: 700;
  color: rgba(255,255,255,0.9);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.mobile-titulo-card {
  padding: 10px 12px;
  border-bottom: 1px solid #e0eaf2;
  background: #eef4f8;
}
.mobile-titulo-card:last-child { border-bottom: none; }
.mobile-titulo-card:nth-child(even) { background: #e4ecf3; }

.mobile-titulo-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.mobile-titulo-cliente { font-size: 12px; font-weight: 600; color: #2c3e50; flex: 1; min-width: 0; }
.mobile-titulo-id      { font-size: 10px; color: #8fa8bc; font-weight: 400; margin-left: 4px; }

.mobile-titulo-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}
.mobile-titulo-field        { display: flex; flex-direction: column; gap: 1px; }
.mobile-titulo-field-label  { font-size: 9px; color: #8fa8bc; font-weight: 600; text-transform: uppercase; letter-spacing: 0.3px; }
.mobile-titulo-field-value  { font-size: 11px; color: #5a6a7a; }
.mobile-titulo-valor        { color: #023449; font-weight: 700; font-size: 12px; }

/* ── Total mobile ──────────────────────────────────────────────────────────── */
.mobile-total-card {
  border: 1px solid #cfd8e3;
  border-radius: 10px;
  background: #f0f4f8;
  padding: 10px 12px;
}
.mobile-total-label {
  display: block;
  font-size: 10px;
  font-weight: 700;
  color: #023449;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 8px;
}
.mobile-total-metrics { display: flex; align-items: center; }

/* ── Empty mobile ──────────────────────────────────────────────────────────── */
.mobile-empty { display: flex; flex-direction: column; align-items: center; padding: 40px 16px; }

/* ── Transition expand ─────────────────────────────────────────────────────── */
.mobile-expand-enter-active,
.mobile-expand-leave-active { transition: opacity 0.2s ease, transform 0.2s ease; }
.mobile-expand-enter, .mobile-expand-leave-to { opacity: 0; transform: translateY(-6px); }
</style>